import React, { useEffect, useRef, useState } from "react";
import { getPortfolioData } from "../../data/portfolioData";
import "./Resume.css";

function SkillsCarousel({ items }) {
  const railRef = useRef(null);
  const [cols, setCols] = useState(3);

  // responsive columns
  useEffect(() => {
    const set = () => {
      const w = window.innerWidth;
      setCols(w >= 1024 ? 3 : w >= 768 ? 2 : 1);
    };
    set();
    window.addEventListener("resize", set);
    return () => window.removeEventListener("resize", set);
  }, []);

  // autoplay
  useEffect(() => {
    const el = railRef.current;
    if (!el) return;
    const tick = () => {
      const card = el.querySelector(".skill-card");
      const step = card ? card.getBoundingClientRect().width + 20 : 280;
      // loop to start when reaching end
      if (el.scrollLeft + el.clientWidth + 5 >= el.scrollWidth) {
        el.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        el.scrollBy({ left: step, behavior: "smooth" });
      }
    };
    const id = setInterval(tick, 2500);
    return () => clearInterval(id);
  }, [cols]);

  const move = (dir) => {
    const el = railRef.current;
    if (!el) return;
    const card = el.querySelector(".skill-card");
    const step = card ? card.getBoundingClientRect().width + 20 : 280;
    el.scrollBy({ left: dir * step, behavior: "smooth" });
  };

  return (
    <div className="skills-carousel">
      <button className="nav prev" onClick={() => move(-1)} aria-label="Previous">‹</button>

      <div className={`skills-rail cols-${cols}`} ref={railRef}>
        {items.map((s) => (
          <div key={s.name} className="skill-card">
            <h3>{s.name}</h3>
            <div className="skill-level">
              <div className="skill-level-fill" style={{ width: s.level }} />
            </div>
            <p className="skill-level-text">{s.level}</p>
          </div>
        ))}
      </div>

      <button className="nav next" onClick={() => move(1)} aria-label="Next">›</button>
    </div>
  );
}

const Resume = () => {
  const { education, experience, skills } = getPortfolioData();

  return (
    <section className="resume-section" id="resume">
      
      {/* Education & Experience */}
      <div className="resume-container">
        <div className="resume-container-left">
          <h2 className="section-title">
            Education
          </h2>
          <div className='education-content'>
            {education.map((edu, index) => (
              <div className='card' key={index}>
                <h3>{edu.qualification}</h3>
                <p>{edu.institution} / {edu.year}</p>
                <p>with {edu.percentage}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="resume-container-right">
          <h2 className="section-title">
            Experience
          </h2>
          <div className='experience-content'>
            {experience.map((exp, index) => (
              <div className='card' key={index}>
                <img src={exp.companyLogoURL} alt="Freelancer in Theni" className='company-logo' />
                <h3>{exp.role}</h3>
                <p>{exp.company} - {exp.location} / {exp.duration}</p>
                <p>{exp.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

    <div className="skills-container">
        <h2 className="section-title">
          Key Skills
        </h2>

        <SkillsCarousel items={skills} />
      </div>

    </section>
  );
};

export default Resume;
